import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { BbAbstractMenuComponent } from '../shared/bb-abstract-menu/bb-abstract-menu.component';
import { RouterEvent, NavigationEnd } from '@angular/router';


@Component({
	selector: 'bb-publication-menu',
	templateUrl: './bb-publication-menu.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class BbPublicationMenuComponent extends BbAbstractMenuComponent implements OnInit {
	constructor(
		private changeDetector: ChangeDetectorRef
	) {
		super(['settings', 'custom-field', 'usage', 'users', 'api-keys', 'upload-credentials', 'global-prebid-settings']);
	}

	ngOnInit() {
		this.subscriptions.add(this.router.events.subscribe((routerEvent: RouterEvent) => {
			if (routerEvent instanceof NavigationEnd) {
				this.changeDetector.detectChanges();
			}
		}));
	}
}
